import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Text } from 'shared/components'
import { InWinImage } from 'routes/shared/components'

import * as styles from './styles'

const TournamentLogoCellComponent = ({ value: { logo, tournamentName } }) => (
  <div css={styles.container}>
    {logo ? (
      <Margin right={1}>
        <InWinImage source={logo} alt={tournamentName} css={styles.logo} />
      </Margin>
    ) : (
      <Text size={16} bold>
        {tournamentName}
      </Text>
    )}
  </div>
)

TournamentLogoCellComponent.propTypes = {
  value: PropTypes.shape(),
}

export default TournamentLogoCellComponent
